import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿SAINT® es ambulatorio u hospitalario?",
    answer:
      "SAINT® es ambulatorio. Se administra con el paciente despierto, sin anestesia ni sedación, en un entorno ambulatorio. No hay hospitalización.",
  },
];

export const esOutpatientOrHospital = makeEsArticle({
  slug: "is-saint-tms-outpatient-or-hospital",
  title: "¿SAINT® es ambulatorio u hospitalario?",
  description:
    "SAINT® es un tratamiento ambulatorio: se administra con el paciente despierto, sin anestesia ni sedación, sin hospitalización.",
  h1: "¿SAINT® es ambulatorio u hospitalario?",
  breadcrumbLabel: "¿SAINT® ambulatorio u hospitalario?",
  shortAnswer:
    "SAINT® es un tratamiento ambulatorio. Se administra con el paciente despierto, sin anestesia ni sedación, en un entorno ambulatorio con suites de tratamiento dedicadas. No hay hospitalización ni sala de recuperación. El paciente puede generalmente conducir al y desde la clínica cada día. SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  keyTakeaways: [
    "SAINT® es ambulatorio.",
    "No usa anestesia ni sedación.",
    "No hay hospitalización ni sala de recuperación.",
    "El paciente puede generalmente conducir cada día.",
    "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos.",
  ],
  sections: [
    {
      heading: "Entorno de tratamiento",
      paragraphs: [
        "SAINT® se administra en un entorno ambulatorio con suites de tratamiento privadas y dedicadas. El paciente permanece despierto durante todo el tratamiento y puede generalmente conducir al y desde la clínica cada día. No se requiere hospitalización ni sala de recuperación.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
